import React from 'react'
import {connect} from 'react-redux'
import {Card, Col, Image, Row, Tabs} from 'antd'
import {withRouter} from 'react-router'
import Cookies from 'universal-cookie'
import axios from 'axios'

import {COOKIE_MAX_AGE, COOKIE_TOKEN} from '../app/constant'
import {userLogin} from '../action/user'
import {artistSave} from '../action/artist'
import {signup, signupGallery} from '../api/user'
import {getArtist} from '../api/artists'
import '../styles/wieldy.less'
import '../asset/less/SignUp.less'
import Title from 'antd/es/typography/Title'
import HttpError from '../component/base/HttpError'
import {ContactsOutlined, DeploymentUnitOutlined, FireOutlined} from '@ant-design/icons'
import {URL_DASHBOARD, URL_PIECES, URL_SIGNUP} from '../const'
import {submitSignUpHubspotForm} from '../api/hubspot'
import {IN_PRODUCT} from "../config/product";
import SignUpArtistForm from "../component/auth/SignUpArtistForm";
import SignUpGalleryForm from "../component/auth/SignUpGalleryForm";
import withBreakpoint from "../app/withBreakpoint";
import logoRoundSmall from "../asset/image/Logo_round-small.png";

@connect(null, {
    userLogin, //passes the info to the store (?)
    artistSave
})
class Signup extends React.Component {
    constructor(props) {
        super(props)
        this.formRef = React.createRef()

        this.state = {
            visible: false,
            confirmLoading: false,
            modelText: '',
            username: '',
            type: 'artist',
            breakpoint: this.props.breakpoint
        }

        this.inviteCode = ''
        this.search_key = props.location?.search ?? ''

        if (this.search_key)
            this.redirectPath = URL_DASHBOARD + this.search_key
        else
            this.redirectPath = URL_PIECES

        if (this.search_key) {
            try {
                const keys = this.search_key.split("&");
                for (const key of keys) {
                    if (key.startsWith("?invite_code=") || key.startsWith("invite_code=")) {
                        this.inviteCode = key.replace("?invite_code=", "").replace("invite_code=", "");
                    } else if (key.startsWith("?redirect=") || key.startsWith("redirect=")) {
                        this.redirectPath = key.replace("?redirect=", "").replace("redirect=", "");
                    } else if (key.startsWith("?type=") || key.startsWith("type=")) {
                        const typeValue = key.replace("?type=", "").replace("type=", "");
                        if (typeValue === 'gallery') {
                            this.state.type = 'gallery';
                        }
                    }
                }
            } catch (e) {
            }
        }
        this.hb_script = document.createElement('script');
    }

    componentDidMount() {
        if (IN_PRODUCT) {
            this.hb_script.src = "//js.hs-scripts.com/7839862.js";
            this.hb_script.async = true;
            document.body.appendChild(this.hb_script);
        }
    }

    componentWillUnmount() {
        if (IN_PRODUCT) {
            document.body.removeChild(this.hb_script)
        }
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if (nextProps.breakpoint) {
            this.setState({breakpoint: nextProps.breakpoint})
        }
    }

    onFinishArtist = (values) => {
        this.setState({
            confirmLoading: true
        })

        signup(values.email, values.password, values.first_name, values.last_name, this.inviteCode)
            .then(async (response) => {
                try {
                     if (IN_PRODUCT) {
                         await submitSignUpHubspotForm(
                             'e85a8511-e21e-417e-ac6d-af36e1028a20',
                             [
                                 {
                                     objectTypeId: '0-1',
                                     name: 'email',
                                     value: values.email
                                 },
                                 {
                                     objectTypeId: '0-1',
                                     name: 'firstname',
                                     value: values.first_name
                                 },
                                 {
                                     objectTypeId: '0-1',
                                     name: 'lastname',
                                     value: values.last_name
                                 },
                                 {
                                     objectTypeId: '0-1',
                                     name: 'sam_invite_code',
                                     value: this.inviteCode
                                 }
                             ],
                             URL_SIGNUP,
                             'SignUpSAM'
                         )
                     }
                } catch (e) {
                    console.log(e)
                }

                this.props.userLogin({
                    id: response.data.user_id,
                    token: response.data.token,
                    email: values.email,
                    artistId: (await getArtist(response.data.user_id)).data.id,
                    userId: response.data.role === 'admin' ? null : response.data.user_id,
                    role: response.data.role,
                    action: 'login'
                })
                axios.defaults.headers.common['Authorization'] = 'Token ' + response.data.token

                const cookies = new Cookies()
                const option = {path: '/'}
                if (values.remember) {
                    option.maxAge = COOKIE_MAX_AGE
                }
                cookies.set(COOKIE_TOKEN, response.data.token, option)
                if (this.redirectPath.startsWith("https://")) {
                    window.location.href = this.redirectPath
                } else {
                    let inviteCodeSuffix = this.inviteCode ? "?invite_code=" + this.inviteCode : ''
                    this.props.history.push({pathname: this.redirectPath + inviteCodeSuffix})
                }
            })
            .catch((error) => {
                HttpError(error)
            }).finally(() => {
            this.setState({
                confirmLoading: false
            })
        })
    }

    onFinishGallery = (values) => {
        this.setState({
            confirmLoading: true
        })
        signupGallery(values.email, values.password, this.inviteCode)
            .then(async (response) => {
                this.props.userLogin({
                    id: response.data.user_id,
                    token: response.data.token,
                    email: values.email,
                    artistId: null,
                    userId: (response.data.role === 'admin' || response.data.role === 'gallery') ? null : response.data.user_id,
                    role: response.data.role,
                    action: 'login'
                })
                axios.defaults.headers.common['Authorization'] = 'Token ' + response.data.token

                const cookies = new Cookies()
                const option = {path: '/'}
                if (values.remember) {
                    option.maxAge = COOKIE_MAX_AGE
                }
                cookies.set(COOKIE_TOKEN, response.data.token, option)
                if (this.redirectPath.startsWith("https://")) {
                    window.location.href = this.redirectPath
                } else {
                    let inviteCodeSuffix = this.inviteCode ? "?invite_code=" + this.inviteCode : ''
                    this.props.history.push({pathname: this.redirectPath + inviteCodeSuffix})
                }
            })
            .catch((error) => {
                HttpError(error)
            }).finally(() => {
            this.setState({
                confirmLoading: false
            })
        })
    }

    render() {
        const signupForms = [
            {
                'title': 'Artist',
                'form': <SignUpArtistForm ins={this}/>
            },
            {
                'title': 'Gallery',
                'form': <SignUpGalleryForm ins={this}/>
            }
        ]

        let paddingStr = '1%'
        let paddingTop = '6%'

        if (this.state.breakpoint?.xs) {
            paddingStr = '0%';
            paddingTop = '16%'
        }
        if (this.state.breakpoint?.sm) paddingStr = '3%'
        if (this.state.breakpoint?.md) paddingStr = '8%'
        if (this.state.breakpoint?.lg) paddingStr = '16%'
        if (this.state.breakpoint?.xl) paddingStr = '16%'
        if (this.state.breakpoint?.xxl) paddingStr = '16%'

        return (
            <div
                style={{
                    height: '100vh',
                    overflowY: 'auto',
                }}
            >

                <Row style={{flexDirection: 'row', height: '100%'}}>
                    <Col xs={24} sm={24} md={24} lg={12}>
                        <div style={{position: 'fixed', left: 24, top: 24, height: 48, width: 120, zIndex: 100}}>
                            <Image src={logoRoundSmall} preview={false} height='48px' width='48px'/>
                        </div>
                        <Card style={{
                            paddingLeft: paddingStr,
                            paddingRight: paddingStr,
                            paddingTop: paddingTop,
                            height: '100%'
                        }}>
                            <div style={{display: 'flex'}}>
                                <Title style={{paddingLeft: 24, paddingRight: 24, paddingTop: 6}} level={2}>
                                    <FireOutlined style={{color: '#0531ad'}}/>
                                    <span style={{paddingLeft: 18}}>Join Now!</span>
                                </Title>
                            </div>
                            <Tabs
                                defaultActiveKey={this.state.type === 'gallery' ? '2' : '1'}
                                items={[ContactsOutlined, DeploymentUnitOutlined].map((Icon, i) => {
                                    const id = String(i + 1);
                                    const item = signupForms[i]
                                    return {
                                        label: (
                                            <span>
                                        <Icon/>
                                                {item.title}
                                      </span>
                                        ),
                                        key: id,
                                        children: <div style={{marginTop: 12}}>{item.form}</div>,
                                    };
                                })}/>
                            <center>
                                <span style={{
                                    marginLeft: 'auto',
                                    marginRight: 'auto',
                                    color: 'grey',
                                    fontSize: '0.6rem'
                                }}>Free for 14 days. No credit card required.</span>
                            </center>

                            <a href={'https://revart.co/'}>
                                <span
                                    style={{color: 'black', position: 'absolute', left: 20, bottom: 10}}>© RevArt</span>
                            </a>
                            <a href={'https://revart.co/privacy/'}>
                                <span style={{
                                    color: 'black',
                                    position: 'absolute',
                                    bottom: 10,
                                    left: 120
                                }}>© Privacy</span>
                            </a>
                        </Card>
                    </Col>
                    <Col md={0} lg={12}
                         style={{backgroundImage: "url('https://revart.co/webstatic/assets/demo/artists/artist-bg5.png')"}}>
                    </Col>
                </Row>
            </div>
        )
    }
}

export default withBreakpoint(withRouter(Signup))
